export default __webpack_public_path__ + "static/media/TBX_logo.8620fbde.png";